import type { ReactNode } from 'react';

export const symbol_all_match: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M502-480ZM117-752q-11-15-3.5-31.5T140-800h467q14.25 0 27 6.37 12.75 6.38 21 17.63l193 253q11 15 2.89 31.5-8.1 16.5-26.52 16.5-7.37 0-13.37-3.5-6-3.5-11-8.5L607-740H200l170 224q12 15.68 12 35.84Q382-460 370-444L200-220h246q10.95 0 18.97 7 8.03 7 10.03 18 2 14-6.5 24.5T446-160H140q-19 0-26.5-16.5T117-208l206-272-206-272Zm587 528-18-18q-9-9-21-8.5t-21 9.5q-9 9-9 21t9 21l39 39q9 9 21 9t21-9l97-96q9-9 9-21t-9-21q-9-9-21-8.5t-21 8.5l-76 74Zm28.5 197q-82.5 0-142-60T531-228q0-83 59.5-143t142-60q82.5 0 142.5 60t60 143q0 81-60 141T732.5-27Z"
		/>
	</svg>
);
